/**
 * 权限铺平
 * @param resources 有权限的菜单
 * @param flatResources 铺平的权限
 */
function flatAllResources(resources, flatResources) {
    resources.forEach(resource => {
        flatResources.push(resource);
        if (resource.children && resource.children.length > 0) {
            flatAllResources(resource.children, flatResources);
        }
    });
}

/**
 * 根据code获取菜单
 * @param resources 有权限的菜单
 * @param code 权限码
 */
function getMenuByCode(resources, code) {
    let flatResources = [];
    flatAllResources(resources, flatResources);
    let obj = null;
    flatResources.forEach(resource => {
        if (resource.code && resource.code === code && resource.isShow) {
            obj = resource;
        }
    });
    return obj;
}

export default {
    getMenuByCode
};
